import { memo } from 'react';
import ThemeConfigContext from '../contexts/ThemeConfigContext';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Allows external implementing libraries to pass in a theming configuration to this wrapper
 * component, where children consumers (i.e. `PrimaryMessage`) determine how and when to use each of
 * the `Theme` records.
 */
const ThemeConfigProvider = /*#__PURE__*/memo(({
  themeConfig,
  children
}) => {
  return /*#__PURE__*/_jsx(ThemeConfigContext.Provider, {
    value: themeConfig,
    children: children
  });
});
ThemeConfigProvider.displayName = 'ThemeConfigProvider';
export default ThemeConfigProvider;